import { ASSESSMENT_TYPE } from 'frontcore/constants/taskManager'
import { getAssessmentType } from 'frontend/composition/configureAssessmentType'

export default function LpaTemplate ({
  actionsInNokCompliance = false,
  allCriteriaMandatory = false,
  active = false,
  assessmentType,
  criteria = null,
  description = null,
  hasFamilies = false,
  hasProducts = false,
  impactSkillMatrix = false,
  isApplyToOperator = false,
  isApplyToStandard = false,
  canKeepSkillMatrixComplianceLevel = false,
  isIluoTemplate = false,
  needSignature = false,
  shouldAutocompletePreviousOKs = false,
  parent = null,
  perimeters = [],
  roles = [],
  teams = [],
  source,
  subSource,
  templateName,
}) {
  this.actionsInNokCompliance = actionsInNokCompliance
  this.allCriteriaMandatory = allCriteriaMandatory
  this.active = active
  this.assessmentType = assessmentType
  this.criteria = criteria
  this.description = description
  this.hasFamilies = hasFamilies
  this.hasProducts = hasProducts
  this.impactSkillMatrix = impactSkillMatrix
  this.isApplyToOperator = isApplyToOperator
  this.isApplyToStandard = isApplyToStandard
  this.isIluoTemplate = isIluoTemplate
  this.needSignature = needSignature
  this.parent = parent
  this.perimeters = perimeters
  this.roles = roles
  this.teams = teams
  this.shouldAutocompletePreviousOKs = shouldAutocompletePreviousOKs
  this.source = source
  this.subSource = subSource
  this.templateName = templateName
  this.canKeepSkillMatrixComplianceLevel = canKeepSkillMatrixComplianceLevel
}

LpaTemplate.prototype = Object.create(LpaTemplate.prototype)

Object.assign(LpaTemplate.prototype, {
  toApiPayload () {
    const isPercentageOrNumeric = this.assessmentType.assessment_type === ASSESSMENT_TYPE.PERCENTAGE || this.assessmentType.assessment_type === ASSESSMENT_TYPE.NUMERIC_SCALE
    const assessmentType = getAssessmentType(this.assessmentType.is_na, this.assessmentType.assessment_type)
    return {
      achieve_rule: [ASSESSMENT_TYPE.VALUE, ASSESSMENT_TYPE.VALUE_NA].includes(this.assessmentType.assessment_type) ? this.assessmentType.default_rule: null,
      active: this.active,
      apply_to_operator: this.isApplyToOperator,
      apply_to_product: this.hasProducts,
      apply_to_standard: this.isApplyToStandard,
      assessment_type: assessmentType,
      criteria: this.criteria,
      description: this.description,
      has_families: this.hasFamilies,
      impact_skill_matrix: this.impactSkillMatrix,
      is_iluo_template: this.isIluoTemplate,
      name: this.templateName,
      need_signature: this.needSignature,
      non_conformities_require_action: this.actionsInNokCompliance,
      all_criteria_mandatory: this.allCriteriaMandatory,
      number_of_measures: this.assessmentType.number_of_measures,
      parent: this.parent,
      percentage_rule: isPercentageOrNumeric ? this.assessmentType.default_rule.rule : null,
      percentage_scores: {
        values: isPercentageOrNumeric ? this.assessmentType.default_rule.percentage_scores : [],
        is_na: isPercentageOrNumeric ? this.assessmentType.is_na : false,
      },
      perimeters: this.perimeters,
      roles: this.roles,
      teams: this.teams,
      source: this.source,
      sub_source: this.subSource,
      can_keep_skill_matrix_compliance_level: this.canKeepSkillMatrixComplianceLevel,
      should_autocomplete_previous_oks: this.shouldAutocompletePreviousOKs,
    }
  },
})
